"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.loadAttributeReducers = void 0;
var tslib_1 = require("tslib");
var identity_1 = tslib_1.__importDefault(require("lodash/identity"));
var loadAttributeRequest = identity_1.default;
var loadAttributeStart = function (state) {
    state.attribute.status = "loading";
    state.attribute.error = undefined;
    state.attribute.data = undefined;
};
var loadAttributeSuccess = function (state, action) {
    state.attribute.status = "success";
    state.attribute.data = action.payload.attribute;
};
var loadAttributeError = function (state, action) {
    state.attribute.status = "error";
    state.attribute.error = action.payload.error;
};
var loadAttributeCancelRequest = identity_1.default;
var loadAttributeCancel = function (state) {
    state.attribute.status = "canceled";
};
/**
 * @internal
 */
exports.loadAttributeReducers = {
    loadAttributeRequest: loadAttributeRequest,
    loadAttributeStart: loadAttributeStart,
    loadAttributeSuccess: loadAttributeSuccess,
    loadAttributeError: loadAttributeError,
    loadAttributeCancelRequest: loadAttributeCancelRequest,
    loadAttributeCancel: loadAttributeCancel,
};
//# sourceMappingURL=loadAttributeReducers.js.map